/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { UserRosterModel, UserRosterModelType } from './UserRosterModel'
import { UserRosterModelSelector } from './UserRosterModel.base'
import { RootStoreType } from './index'

/**
 * TeachingTableRosterBase
 * auto generated base class for the model TeachingTableRosterModel.
 */
export const TeachingTableRosterModelBase = ModelBase.named('TeachingTableRoster')
  .props({
    __typename: types.optional(types.literal('TeachingTableRoster'), 'TeachingTableRoster'),
    observers: types.union(types.undefined, types.array(types.late(() => UserRosterModel))),
    players: types.union(types.undefined, types.array(types.late(() => UserRosterModel)))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class TeachingTableRosterModelSelector extends QueryBuilder {
  observers(
    builder:
      | string
      | UserRosterModelSelector
      | ((selector: UserRosterModelSelector) => UserRosterModelSelector)
      | undefined
  ) {
    return this.__child('observers', UserRosterModelSelector, builder)
  }
  players(
    builder:
      | string
      | UserRosterModelSelector
      | ((selector: UserRosterModelSelector) => UserRosterModelSelector)
      | undefined
  ) {
    return this.__child('players', UserRosterModelSelector, builder)
  }
}
export function selectFromTeachingTableRoster() {
  return new TeachingTableRosterModelSelector()
}

export const teachingTableRosterModelPrimitives = selectFromTeachingTableRoster()
